/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2020-12-24 16:58:56
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\trill\trillRouter.js
 * @Description:  抖音渠道路由
 */
'use strict';
angular.module('editTrillRouterModule', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('front.editctr.trill', {
            url: '/trill',
            views: {
                'trill@front.editctr': {
                    templateUrl: './editingCenter/trill/left_tpl.html',
                    controller: 'EditTrillLeftCtrl'
                }
            }
        });
    }]);
